export const name = 'GameOptions';

import { useMainStore } from '@/stores/main'
import * as Server from '@/services/Server'

/**
 * In-game options saved on the server (user_settings).
 *
 * They are not client preferences: the game reads them from the signed launch link
 * (GameServerController::makeToken), so a change here applies from the next time the player gets
 * on track — nothing is pushed to a running session.
 */

/** Logged-in user: the in-game options the server holds. */
export function current()
{
  const store = useMainStore()

  return Server.get(store.apiPath.user_settings)
    .then(response => ({
      color: response.data?.data?.color ?? null,
      color2: response.data?.data?.color2 ?? null,
      color3: response.data?.data?.color3 ?? null,
      color4: response.data?.data?.color4 ?? null,
      livery: response.data?.data?.livery ?? null,
      // The crest next to the name (its shape and the order of its zones) and the shapes there are:
      // the page shows the ones the current paint has colours for (config/crests.php).
      crest: response.data?.data?.crest ?? { shape: 'solid', order: [1] },
      crests: response.data?.data?.crests ?? [],
      headToHead: Boolean(response.data?.data?.headToHead),
      // Which colours and liveries THIS account may pick. The server decides (see AppearanceLib),
      // and the lists travel with the settings it already answers with: the page draws them and
      // hides the rest, so it never has to know which tier anything belongs to.
      colors: response.data?.data?.colors ?? [],
      anyColor: Boolean(response.data?.data?.anyColor),
      liveries: response.data?.data?.liveries ?? [],
    }))
}

/** Logged-in user: save the in-game options on the server. */
export function save({ color, color2, color3, color4, livery, crest, headToHead })
{
  const store = useMainStore()

  return Server.put(store.apiPath.user_settings, { color, color2, color3, color4, livery, crest, headToHead })
    .then(response => ({
      color: response.data?.data?.color ?? color,
      color2: response.data?.data?.color2 ?? color2,
      color3: response.data?.data?.color3 ?? color3,
      color4: response.data?.data?.color4 ?? color4,
      livery: response.data?.data?.livery ?? livery,
      crest: response.data?.data?.crest ?? crest,
      headToHead: Boolean(response.data?.data?.headToHead),
    }))
}
